import store from '../store/store';
import NavBarData from 'owa-service/lib/contract/NavBarData';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setBposNavBarData', function setBposNavBarData(
    bposNavBarData: NavBarData
) {
    store.bposNavBarData = bposNavBarData;
});
